import { useQuery } from "@tanstack/react-query";

import { clientsQuery } from "#modules/clients/infra/clients.query";

export const useClients = () => {
  const { data, ...rest } = useQuery({
    ...clientsQuery(),
  });

  return { clients: data ?? [], ...rest };
};
